module.exports = __webpack_public_path__ + "static/media/challenge-art-helicopter.3c888e08.png";